import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-workspaces",
  "use": "icon-menu-workspaces-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-workspaces\">\n    <rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n    <path d=\"M8.69531 16L6.45703 7.54492H8.29688L9.61523 13.5859H9.70898L11.25 7.54492H12.7441L14.3145 13.5859H14.4082L15.7148 7.54492H17.543L15.2988 16H13.6406L12.041 10.3047H11.9473L10.3652 16H8.69531Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol